export default __webpack_public_path__ + "static/media/before-trip.0ea91186.png";